import { gql } from '@apollo/client';

import { supplierDetailsFragment } from '../fragments/supplierFragments.gql';

export const SuppliersPageCreateSupplierMutation = gql`
  mutation SuppliersPageCreateSupplier($supplier: SupplierCreateInput!) {
    supplierCreate(supplier: $supplier) {
      ...SupplierDetailsFragment
      __typename
    }
  }
  ${supplierDetailsFragment}
`;
